import React from 'react';
import styles from './ManagmentBlock.css';
import TEXTS from '@/constants/texts';

const ManagmentBlock: React.FunctionComponent = () => (
	<div className={styles.managmentBlock}>
		<div>
			<p className={styles.mainTitle}>{TEXTS.managmentTitle}</p>

			<div className={styles.jsonDescription}>
				<p className={styles.descriptionText}>
					{TEXTS.managmentJsonDescription}
				</p>
			</div>
		</div>

		<div className={styles.imagesContainer}>
			<div className={styles.imageBlock}>
				<img src="https://img.imgsmail.ru/static.promo/jsonld-demo/code.jpg" className={styles.image} />
				<p className={styles.imageFooter}>{TEXTS.managmentLetterImage}</p>
			</div>

			<div className={styles.imageBlock}>
				<img src="https://img.imgsmail.ru/static.promo/jsonld-demo/die.jpg" className={styles.image} />
				<p className={styles.imageFooter}>{TEXTS.managmentDieImage}</p>
			</div>
		</div>

		<div className={styles.argumentsBlock}>
			<p className={styles.mainTitle}>{TEXTS.managmentArgumentsTitle}</p>

			<div className={styles.arguments}>
				{TEXTS.managmentArguments.map((arg, index) => (
					<div className={styles.argument} key={index}>
						<div className={styles.stepCircle}>
							<p className={styles.circleText}>{index + 1}</p>
						</div>
						<p className={styles.descriptionText}>{arg}</p>
					</div>
				))}
			</div>
		</div>
	</div>
);

export default ManagmentBlock;
